import { AxiosResponse } from "axios";
import { apiClient } from "@store/services/checkoutClient";

export async function securePost(apiRoute: string, apiToken: string | number, locale: string, data: any): Promise<AxiosResponse> {
    return apiClient.post(
        composeUrlParams(apiRoute, apiToken, locale),
        data
    );
}

export async function secureGet(apiRoute: string, apiToken: string | number, locale: string): Promise<AxiosResponse> {
    return apiClient.get(
        composeUrlParams(apiRoute, apiToken, locale)
    );
}

function composeUrlParams(apiRoute: string, apiToken: string | number, locale: string): string {
    const url = new URL(apiRoute);
    url.searchParams.set('auth', apiToken.toString());
    url.searchParams.set('culture', locale);

    return url.toString();
}
